module.exports = __webpack_public_path__ + "static/img/map.f9186042.png";